<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.statistics_manage')}}<span class="page-header-breadcrumb">></span>{{ $t('words.chatting_usage_statistics') }}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: tooltipDesc }"><i class="icon icon-info-circle-line"></i></span></h3>
                    <div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
                <div class="page-sub-header clearfix">
                    <div class="form-inline float-left">
                        <div class="control-group">
                            <label for="select_channel" class="sr-only">{{ $t('words.channel') }}</label>
                            <select id="select_channel" :placeholder="$t('words.channel')">
                                <!--<option value="">All Channels</option>-->
                                <!--<option :value="channel.id" v-for="channel in select.channels" :key="channel.id">{{ channel.title }}</option>-->
                            </select>
                        </div>
                        <div class="control-group">
                            <label for="select_live" class="sr-only">{{ $t('words.broadcast') }}</label>
                            <select id="select_live" :placeholder="$t('words.broadcast')">
                                <!--<option value="">All Lives</option>-->
                                <!--<option :value="broadcast.id" v-for="broadcast in select.broadcasts" :key="broadcast.id">{{ broadcast.title }}</option>-->
                            </select>
                        </div>
                        <div class="form-checkbox ml-2">
                            <input type="checkbox" v-model="includeTrashedChannel" id="includeTrashedChannel">
                            <label for="includeTrashedChannel">{{ $t('words.include_removed_channels')}}</label>
                        </div>
                    </div>
                    <div class="module-action-group float-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period === 'custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="module" v-if="loadSummary">
                <div class="module-body">
                    <ul class="dashboard">
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.live_counts') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.live_count }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.chatting_unique_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.unique_count }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.chatting_message_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.message_count }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.average_chatting_unique_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.average_unique_count }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                            <h5 class="dashboard-title">{{ $t('words.average_chatting_message_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.average_message_count }}</p>
                        </li>
                    </ul>
                </div>
            </div>

<!--            <div class="module">-->
<!--                <div class="module-header">-->
<!--&lt;!&ndash;                    <h5 class="module-title">{{ $t('words.chatting_usage_statistics') }}</h5>&ndash;&gt;-->
<!--                    <div class="module-header-action">-->
<!--                        <select style="width:80px" id="interval" v-model="interval">-->
<!--                            <option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>-->
<!--                        </select>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div :class="{'module-body': true, 'chart_loading': chartData.loading}">-->
<!--                    <chatting-usage-chart ref="chart" :chartData="chartData" :interval="interval" :created="chartData.created"></chatting-usage-chart>-->
<!--                </div>-->
<!--            </div>-->

            <div class="module">
                <div :class="{'module-body': true}">
                    <div class="module-action-group" style="margin-bottom: 24px">
                        <nav aria-label="Page navigation" class="ml-auto">
                            <ul class="pagination">
                                <li class="page-info">
                                    {{ $t('paragraphs.page_navigation', { total: broadcasts.meta.total, from: ((broadcasts.meta.current_page - 1) * broadcasts.meta.per_page + 1), to: (broadcasts.meta.current_page === broadcasts.meta.last_page ? broadcasts.meta.total : broadcasts.meta.per_page * broadcasts.meta.current_page )}) }}
                                </li>
                                <li :class="{'page-item': true, disabled: !broadcasts.links.prev }">
                                    <button class="page-link" aria-label="Previous" @click="loadBroadcasts(broadcasts.links.prev)" v-if="broadcasts.links.prev">
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                    <button class="page-link" aria-label="Previous" v-else>
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                </li>
                                <li :class="{'page-item': true, disabled: !broadcasts.links.next }">
                                    <button class="page-link" aria-label="Next" @click="loadBroadcasts(broadcasts.links.next)" v-if="broadcasts.links.next">
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                    <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="table--responsive">
                        <table class="table table-data">
                            <colgroup>
                                <!--                    <col width="48px" v-if="caller==='channel'">-->
                                <col style="min-width: 164px; width: 20%;">
                                <col style="min-width: 164px; width: 20%;">
                                <col>
                                <col>
                                <col>
                                <col>
                            </colgroup>
                            <thead>
                            <tr>
                                <th>{{ $t('words.channel_name') }}</th>
                                <th>{{ $t('words.live_name') }}</th>
                                <th>{{ $t('words.started_at') }}</th>
                                <th>{{ $t('words.ended_at') }}</th>
                                <th>{{ $t('words.chatting_unique_count') }}</th>
                                <th>{{ $t('words.chatting_message_count') }}</th>
                            </tr>
                            </thead>
                            <tbody v-if="broadcasts.load && (broadcasts.data.length > 0)">
                            <!--                            <tbody v-if="broadcasts.load & (broadcasts.meta.total !== 0)">-->
                            <tr v-for="broadcast in broadcasts.data" :key="broadcast.id">
                                <td>
                                    <span class="list__channel__name" v-tooltip="{ content: broadcast.channel_title, html:false }">{{ broadcast.channel_title }}</span>
                                </td>
                                <td>
                                    <span class="list__channel__name" v-tooltip="{ content: broadcast.title, html:false }">{{ broadcast.title }}</span>
                                </td>
                                <td>{{ renderDatetime(broadcast.started_at) }}</td>
                                <td>{{ renderDatetime(broadcast.paused_at) }}</td>
                                <td>{{ broadcast.chatting_unique_count}}</td>
                                <td>{{ broadcast.chatting_message_count}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="broadcasts.load && (broadcasts.data.length === 0)">
                            <tr>
                                <td colspan="6" class="td__message">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="6" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
// import ChattingUsageChart from './chart/ChattingUsageChart';
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import 'selectize';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        // ChattingUsageChart,
        VueDatePicker,
    },
    data() {
        return {
            intervals: ['1h', '1d'],
            selectedChannel: '',
            selectize_channels: null,
            selectize_broadcasts: null,
            selectedBroadcast: '',
            includeTrashedChannel: false,
            channel: {},
            broadcast: {},
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            Selectize: null,
            interval: '5m',
            // chartData: {
            //     loading: false,
            //     labels: null,
            //     results: {
            //         unique: {},
            //         chat: {},
            //     },
            //     created: null,
            // },
            summaryData: {
                live_count: 0,
                unique_count: 0,
                message_count: 0,
                average_unique_count: 0,
                average_message_count: 0,
            },
            loadSummary: false,
            // end random chart
            broadcasts: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
        };
    },
    beforeDestroy() {
        this.data = {};
    },
    mounted() {
        const self = this;
        // const selectizeObj = $('#interval').selectize({
        //     maxItems: 1,
        //     create: true,
        //     onChange(value) {
        //         self.interval = value;
        //         self.initChartData();
        //         self.getChartData();
        //     },
        // });
        // this.Selectize = selectizeObj[0].selectize;

        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            // this.loadChannel();
            this.initSelectableDate('90d');
            this.changePeriod('1d');
            this.loadSelectChannel();
            this.loadBroadcasts();
        },
        adjustInterval() {
            // let adjustInterval = '5m';
            let adjustInterval = '1h';
            if (this.$moment(this.endDay).subtract(29, 'day') >= this.$moment(this.startDay)) {
                adjustInterval = '1d';
            } else if (this.$moment(this.endDay).subtract(6, 'day') >= this.$moment(this.startDay)) {
                adjustInterval = '1h';
            } else if (this.$moment(this.endDay).subtract(2, 'day') >= this.$moment(this.startDay)) {
                // adjustInterval = '10m';
                adjustInterval = '1h';
            }
            this.interval = adjustInterval;
            // this.Selectize.setValue(this.interval, true);
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';
            this.adjustInterval();
            this.loadData();
        },
        loadData() {
            this.initSummaryData();
            this.getSummaryData();

            // this.initChartData();
            // this.getChartData();
            this.loadBroadcasts(this.chattingStatisticsBroadcastsApiUri);
        },
        loadChannel() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
            });
        },
        loadBroadcasts() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.broadcastApi).then((response) => {
                this.broadcast = response.data.data;
            });
        },
        loadSelectChannel() {
            const self = this;
            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.loadSummary = false;
                    self.selectedChannel = value;
                    self.selectedBroadcast = '';
                    // self.loadChannel();
                    self.loadData();
                    // self.loadRecordFiles(self.recordingFilesApiUri);

                    // 방송 검색되도록 수정.
                    self.selectize_broadcasts.onSearchChange('');
                    // self.selectize_broadcasts.clear();
                    // self.selectize_broadcasts.clearOptions();
                    // self.selectize_broadcasts.disable();
                    // self.selectize_broadcasts.load((query, callback) => {
                    //     if (!value.length) {
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //         return;
                    //     }
                    //     const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    //     axios.get(broadcastUri).then((response) => {
                    //         self.selectize_broadcasts.enable();
                    //         response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                    //         callback(response.data.data);
                    //     }).catch((error) => {
                    //         // self.$toasted.error('Failed to load lives');
                    //         // console.log(error.response.data.errors);
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //     });
                    // });

                    // self.selectize_broadcasts.setValue('', true);
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}&with_trashed=${self.includeTrashedChannel}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: self.$t('words.all_channels') });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load channels');
                        console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_channels') }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
            this.loadSelectBroadcast();
        },
        loadSelectBroadcast() {
            const self = this;
            const selectizeObj = $('#select_live').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                maxItems: 1,
                create: false,
                onChange(value) {
                    self.selectedBroadcast = value;
                    // self.loadRecordFiles(self.recordingFilesApiUri);
                    // if (!value.length) return;

                    self.loadBroadcasts();
                    self.loadData();
                },
                load(query, callback) {
                    this.clearOptions();
                    if (self.selectedChannel.length === 0) {
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                        return;
                    }
                    const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    axios.get(broadcastUri).then((response) => {
                        // self.selectize_broadcasts.enable();
                        response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                        callback(response.data.data);
                    }).catch((error) => {
                        // self.$toasted.error('Failed to load lives');
                        // console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    });
                },
            });

            this.selectize_broadcasts = selectizeObj[0].selectize;
            // this.selectize_broadcasts.clearOptions();
            // this.selectize_broadcasts.disable();
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.adjustInterval();
            this.loadData();
        },
        loadBroadcasts(broadcastApi) {
            this.broadcasts.load = false;
            axios.get(broadcastApi).then((response) => {
                this.broadcasts = response.data;
                this.broadcasts.load = true;
            });
        },
        initSummaryData() {
            this.loadSummary = false;
            this.summaryData.live_count = 0;
            this.summaryData.unique_count = 0;
            this.summaryData.message_count = 0;
            this.summaryData.average_unique_count = 0;
            this.summaryData.average_message_count = 0;
        },
        initChartData() {
            this.chartData.loading = true;
            this.chartData.labels = [];
            this.chartData.results.join = [];
            this.chartData.results.chat = [];
            // this.chartData.created = moment().utc().format('X');
            this.$refs.chart.initialize();
        },
        async getSummaryData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/chatting_statistics/usage_summary${this.appendUriAndQuery}`;
            const self = this;
            await axios.get(apiLoc).then((response) => {
                self.summaryData.live_count = response.data.summary.live_count;
                self.summaryData.unique_count = response.data.summary.unique_count;
                self.summaryData.message_count = response.data.summary.message_count;
                self.summaryData.average_unique_count = response.data.summary.average_unique_count;
                self.summaryData.average_message_count = response.data.summary.average_message_count;
                self.loadSummary = true;
            });
        },
        async getChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/chatting_statistics/usage_chart${this.appendUriAndQuery}`;
            const self = this;
            await axios.get(apiLoc).then((response) => {
                self.chartData.labels = response.data.labels;
                self.chartData.results.unique = response.data.results.unique;
                self.chartData.results.chat = response.data.results.chat;
                // self.chartData.created = moment().utc().format('X') + 5;
                this.$refs.chart.initialize();
                this.chartData.loading = false;
            }).catch((error) => {
                this.chartData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.selectedBroadcast}`;
        },
        getExportUrl() {
            return `/cms/${this.selectedServiceAccount.key}/chatting_statistics/export_usage${this.appendUriAndQuery}`;
        },
        chattingStatisticsBroadcastsApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/chatting_statistics/broadcasts${this.appendUriAndQuery}`;
        },
        appendUriAndQuery() {
            let query = '';
            if (this.selectedChannel !== '') {
                query += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    query += `/${this.selectedBroadcast}`;
                }
            }
            query += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.interval}`;

            return query;
        },
        tooltipDesc() {
            return `${this.$t('paragraphs.chatting_statistics_tip')}<br/>${this.$t('paragraphs.statistics_timezone_tip')}`;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        includeTrashedChannel(newValue) {
            this.selectize_channels.onSearchChange($('#select_channel').val());
        },
    },
};
</script>
